import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { SetContextLink } from "@apollo/client/link/context";

import { supabase } from "@/utils/supabase";

const SUPABASE_URL = process.env.EXPO_PUBLIC_SUPABASE_URL!;
const SUPABASE_KEY = process.env.EXPO_PUBLIC_SUPABASE_PUBLISHABLE_KEY!;

const httpLink = new HttpLink({
  uri: `${SUPABASE_URL}/graphql/v1`,
});

const authLink = new SetContextLink(async ({ headers }) => {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  return {
    headers: {
      ...headers,
      apikey: SUPABASE_KEY,
      authorization: session?.access_token
        ? `Bearer ${session.access_token}`
        : "",
    },
  };
});

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});
